import request from '@/config/axios'
import { format } from 'date-fns'

export const getListApi = async (params: any): Promise<IResponse> => {
  return await request.get({ url: '/tutorialPriors', params })
}

const getShouldComeShowClass = (tutorialPriors, r) => {
  const { sum, realSum, otherSum } = getShouldCome(r, tutorialPriors)

  return `應到${sum.length}人 實到${realSum.length}${otherSum.length > 0 ? `(+${otherSum.length})` : ''}人`
}

const getShouldComeShowManager = (tutorialPriors, r) => {
  const { sum, realSum, otherSum } = getShouldCome(r, tutorialPriors)

  return `${realSum.length}/${sum.length} ${otherSum.length > 0 ? `(+${otherSum.length})` : ''}`
}

//取得應到而未到的學生
const getShouldComeNotArrivedStudents = (tutorialPriors, r) => {
  const { sum, realSum, otherSum } = getShouldCome(r, tutorialPriors)

  return sum.filter((x) => {
    return !realSum.find((y) => y.student_id === x.student_id)
  })
}

export default {
  getListApi,
  getShouldComeShowClass,
  getShouldComeShowManager,
  getShouldComeNotArrivedStudents
}

function getShouldCome(r: any, tutorialPriors: any) {
  const day = format(new Date(r.time), 'EEE').toLocaleLowerCase()
  const time = parseInt(format(new Date(r.time), 'HH'))
  //早上6點到中午12點傳回_morning
  //下午12點到晚上6點傳回_afternoon
  //晚上6點到晚上12點傳回_evening
  //其他傳回空字串
  const timeStr = time >= 6 && time < 12 ? '_morning' : time >= 12 && time < 18 ? '_afternoon' : time >= 18 && time < 24 ? '_evening' : ''

  const sum = tutorialPriors.filter((x) => {
    //取得這個物件所有的key
    //如果這個物件的key字串有包含day
    //就回傳這個物件的key的value
    for (let i = 0; i < Object.keys(x).length; i++) {
      const el = Object.keys(x)[i]
      if (day && timeStr && el.includes(day + timeStr)) {
        return x[el]
      }
    }
    return false
  })

  //計算在應到人數內的實到人數
  const realSum = r.tutorial_attends.filter((x) => {
    return x.is_attend && sum.findIndex((y) => y.student_id === x.student_id) !== -1
  })

  //計算不在應到人數內的實到人數
  const otherSum = r.tutorial_attends.filter((x) => {
    return x.is_attend && sum.findIndex((y) => y.student_id === x.student_id) === -1
  })
  return { sum, realSum, otherSum }
}

